import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteFleteFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='FLETE' htmlFor='input-importeFlete' md={6} alignRightAt='md' />
      <Col md={6}>
        <Form.InputNumber id='input-importeFlete' name='input-importeFlete' value={iValue} disabled />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteFleteFormGroup)
